<template>
    <el-select
        v-model="selectedService"
        @input="$emit('input', selectedService)"
        @change="$emit('change', selectedService)"
    >
        <el-option
            v-for="option in expiredServiceOptions"
            :key="option.value"
            :label="option.label"
            :value="option.value"
        />
    </el-select>
</template>
<script>

export default {
  name: 'ExpiredSelect',
  props: {
    value: {
      type: [Boolean, String],
      default: 'NO',
    },
  },
  data() {
    return {
      selectedService: this.value === 'YES' || this.value === true,
      expiredServiceOptions: [
        { label: 'NO', value: false },
        { label: 'YES', value: true }
      ],
    };
  },
  watch: {
    value(newValue) {
      this.selectedService = newValue === 'YES' || newValue === true;
    },
  },
};
</script>
